
const config = require('../../../../../../config/locales_json/packs/private/postulations/postulations.json');
const language = $('body').data("language");

$(document).ready(function() {
  /************************************************** */
  // 
  //            HANDLER MODAL ASISTENTE
  //
  /************************************************** */
  
  $('div#profileEventModal').on("show.bs.modal", function(e){
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var active_panel = $("#hirint.active.no-report")

    if (active_panel.length > 0) {
      var user_id = active_panel.data('userid');

      $.ajax({
        type: 'GET',
        url: '/get_hirint_test',
        dataType: 'script',
        data: {
          user_id: user_id,
          authenticity_token: AUTH_TOKEN
        },
        beforeSend: function() {
          // Muestra el mensaje "Cargando" usando SweetAlert2
          Swal.fire({
            title: 'Cargando Información',
            icon: 'info',
            allowEscapeKey: false,
            allowEnterKey: false,
            buttonsStyling: false,
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false
          });
        },
        success: function(response, textStatus, jqXHR) {
          Swal.close();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // Muestra alerta indicando que hubo un error
          Swal.fire({
            text: 'Hubo un problema al cargar el reporte. Por favor vuelve a intentar en unos minutos.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn btn-fj-purple"
            }
          });
        }
      });
    }
  })

  $('div#profileEventModal').on('shown.bs.modal', function (e) {
    handleModalFooterSwipeButtons();
  })

  $('div#profileEventModal').on("click", "#swipe-actions button.swipe-btn", function(e) {
    var btn = $(this);
    swipeToRequest(btn);
  })

  $('div#profileEventModal').on("click", "#modal-footer-swipe-actions button.swipe-btn", function(e) {
    var clickedBtn = $(this);
    var swipeToNext = clickedBtn.hasClass('next');
    
    var swipeToBtnAction = swipeToNext ? $('#swipe-actions button.swipe-btn.next') : $('#swipe-actions button.swipe-btn.previous');
    if (swipeToBtnAction.length > 0) swipeToRequest(swipeToBtnAction);
  })


  function swipeToRequest(swipeToBtnAction) {
    var btn = swipeToBtnAction;
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var href = btn.data('href')
    var all_id_array= $('input#all_ids').val();
    
    var queryParams = window.location.search;
    if (queryParams) queryParams = queryParams.replace('?', '&');
  
    var requestUrl = queryParams ?  href + queryParams : href
    var isDisabled = btn.hasClass('disabled')
    
    if (isDisabled) return;
  
    $('button.swipe-btn').addClass('disabled');
  
    $.ajax({
      type: "POST",
      url: requestUrl,
      dataType: 'script',
      data: {
        authenticity_token: AUTH_TOKEN,
        all_postulants: all_id_array
      },
      beforeSend: function() {
        Swal.fire({
          title: 'Cargando',
          icon: 'info',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false
        });
      },
      success: function(response) {
        $('button.swipe-btn').removeClass('disabled');
        handleModalFooterSwipeButtons();
        Swal.close();
      },
      error: function(xhr, status, error) {
        $('button.swipe-btn').removeClass('disabled');
        $('#profileEventModal button.swipe-btn').addClass('d-none');
        Swal.fire({
          text: 'Hubo un problema al cambiar de postulante. Intente cambiar manualmente. Si el problema se repite, contáctenos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });
  }
  
  function handleModalFooterSwipeButtons() {
    var swipeNextBtn = $("#swipe-actions button.swipe-btn.next"); 
    var swipePreviousBtn = $("#swipe-actions button.swipe-btn.previous");
  
    var modalSwipeNextBtn = $("#modal-footer-swipe-actions button.swipe-btn.next"); 
    var modalSwipePreviousBtn = $("#modal-footer-swipe-actions button.swipe-btn.previous");
  
    if (swipeNextBtn.length > 0 && modalSwipeNextBtn.length > 0) {
      var isShown = !swipeNextBtn.hasClass('d-none');
      if (isShown) {
        modalSwipeNextBtn.removeClass('d-none disabled');
      } else {
        modalSwipeNextBtn.addClass('d-none disabled');
      }
    } else {
      modalSwipeNextBtn.addClass('d-none disabled');
    }
  
    if (swipePreviousBtn.length > 0 && modalSwipePreviousBtn.length > 0) {
      var isShown = !swipePreviousBtn.hasClass('d-none');
      if (isShown) {
        modalSwipePreviousBtn.removeClass('d-none disabled');
      } else {
        modalSwipePreviousBtn.addClass('d-none disabled');
      }
    } else {
      modalSwipePreviousBtn.addClass('d-none disabled');
    }
  }
  
  function getTranslationValue(config, keys, defaultValue) {
    if (keys.length <= 1) return defaultValue;
  
    let currentTranslation;
    let firstIteration = true;
  
    for (let key of keys) {
  
      if (firstIteration) {
  
        if (config[key]) {
          currentTranslation = config[key];
          firstIteration = false;
        } else {
          firstIteration = false;
          return defaultValue;
        }
      } else {
  
        if (currentTranslation[key]) {
          currentTranslation = currentTranslation[key];
        } else {
          return defaultValue;
        }
      }
    }
  
    return currentTranslation;
  }

  /************************************************** */
  // 
  //           FIN HANDLER MODAL ASISTENTE
  //
  /************************************************** */


  /************************************************** */
  // 
  //            HANDLER CHECKBOXES
  //
  /************************************************** */

  /****************
  * Validando si la variable de los postulantes esta vacia, se bloquea el dropdown de los estados
  * Sino se deja habilitado
  */
  const jobId = $("#list_participants").data("job");

  if (localStorage.getItem("participantIds_"+jobId) == null || localStorage.getItem("participantIds_"+jobId) === '' || localStorage.getItem("participantIds_"+jobId) === 'null') {
    localStorage.setItem("participantIdsSelectAll"+jobId, false);
    $('input#check_for_select_all').prop("checked", false);
    $('button#menu_bulk_action').prop('disabled', true)
    //$('a#link_download_selected').css('display','none');
    $('a#link_download_selected_mail').css('display','none');
    $('button#menu_bulk_action').addClass('disabled')
  }else{
    $('button#menu_bulk_action').prop('disabled', false);
    //$('a#link_download_selected').css('display','block');
    $('a#link_download_selected_mail').css('display','inline-flex');
    $('button#menu_bulk_action').removeClass('disabled');
  }

  /****************
  * si la variable de los postulantes tiene valores, se seleccionan los checkbox correspondientes
  */

  if (localStorage.getItem("participantIds_"+jobId) !== null) {
    var selectedOnReloadPostulants = localStorage.getItem("participantIds_"+jobId).split(',')
    $.each(selectedOnReloadPostulants, function(index, value) {
      $('#check_for_participant_'+value).prop("checked", true);
    });
  }

  /****************
  * si la variable de seleccion de todos los postulantes es true, se selecciona el checkbox
  */

  if (localStorage.getItem("participantIdsSelectAll"+jobId) === "true") {
		$('input#check_for_select_all').prop("checked", true);
	}

  /****************
  * Evento que permite guardar y seleccionar todos los ids de los postulantes
  */
  $('input#check_for_select_all').on('change', function(e){
    // alert($("input[name='check_for_postulant']:checked").length);
    if ($(this).is(':checked')) {
      if ($("input[name='check_for_postulant']:checked").length > 0){
        localStorage.setItem("participantIdsSelectAll"+jobId, false);
        localStorage.setItem("participantIds_"+jobId, null);
        $('input.check_postulant').prop("checked", false);
        $('button#menu_bulk_action').prop('disabled', true);
        //$('a#link_download_selected').css('display','none');
        $('a#link_download_selected_mail').css('display','none');
        $('button#menu_bulk_action').addClass('disabled');
        $(this).prop("checked", false);
      } else {
        // Contiene todo lo que devuelve la db, ya sea todos o los filtrados
        var all_id_array= $('input#all_ids').val();

        localStorage.setItem("participantIdsSelectAll"+jobId, true);
        localStorage.setItem("participantIds_"+jobId, all_id_array);
        $('input.check_postulant').prop("checked", true);
        $('button#menu_bulk_action').prop('disabled', false);
        //$('a#link_download_selected').css('display','block');
        $('a#link_download_selected_mail').css('display','inline-flex');
        $('button#menu_bulk_action').removeClass('disabled');
      }
		} else {
			localStorage.setItem("participantIdsSelectAll"+jobId, false);
			localStorage.setItem("participantIds_"+jobId, null);
      $('input.check_postulant').prop("checked", false);
      $('button#menu_bulk_action').prop('disabled', true);
      //$('a#link_download_selected').css('display','none');
      $('a#link_download_selected_mail').css('display','none');
			$('button#menu_bulk_action').addClass('disabled');
		}

	});

  /****************
  * Evento que permite ir guardando y checkeando postulantes individuales
  */
  $("div#attendees-list").on("click", "input.check_postulant", function() {
		getParticipantsIds($(this).val())
		candidatesIds = localStorage.getItem("participantIds_"+jobId);
		if (localStorage.getItem("participantIds_"+jobId) == null || localStorage.getItem("participantIds_"+jobId) === ''){
      $('button#menu_bulk_action').prop('disabled', true)
      //$('a#link_download_selected').css('display','none');
      $('a#link_download_selected_mail').css('display','none');
			$('button#menu_bulk_action').addClass('disabled')
		}else{
      $('button#menu_bulk_action').prop('disabled', false);
      //$('a#link_download_selected').css('display','block');
      $('a#link_download_selected_mail').css('display','inline-flex');
			$('button#menu_bulk_action').removeClass('disabled');
		}
  });


  // Funcion para Enivar al email los seleccionados
  $("div#list_participants").on("click", "a#link_download_selected_mail", function(e) {
    e.preventDefault();
    var link_selected= $(this);
    candidatesIds = localStorage.getItem("participantIds_"+jobId);
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    // Revisamos si la tabla es del admin
    var checkAdminUser = $("#list_participants #participants").hasClass("admin")
    // Si es el admin
    if(checkAdminUser) {
      var slug = $("#list_participants #participants").attr("data-slug")
      var url = '/admin/clientes/'+ slug +'/ofertas/' + link_selected.data('ofert-id') + '/send_selected_postulants'
    } else {
      var url = '/empresa/ofertas/' + link_selected.data('ofert-id') + '/send_selected_postulants'
    }

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'script',
      data: {
        ids: candidatesIds,
        authenticity_token: AUTH_TOKEN
      }
    });
  });

  // Funcion que se ejecuta al clickear un checkbox en postulantes
  function getParticipantsIds(value) {
    const jobId = $("#list_participants").data("job");

    var allVals = []
    var stored_ids = localStorage.getItem("participantIds_"+jobId);
    // debugger;
    if (!(stored_ids === "null" || stored_ids === null|| stored_ids === '')) {
      allVals = stored_ids.split(',')
    }
    if ($.inArray(value, allVals) >= 0) {
      allVals.splice( $.inArray(value, allVals), 1 );
    }else {
      allVals.push(value)
    }

    // Removiendo los nullos
    var filteredallVals = allVals.filter(function (el) {
      return (el != "null" || el != "");
    });

    localStorage.setItem("participantIds_"+jobId, filteredallVals.join(','))

    // Si todos los checkbox seleccionados son igual/diferentes que el numero de ids de la consulta
    //que marque/desmarque el checkbox de select all

    if (filteredallVals.length === $('input#all_ids').val().split(',').length ){
      $('input#check_for_select_all').prop("checked", true);
      localStorage.setItem("participantIdsSelectAll"+jobId, true);
    }else{
      $('input#check_for_select_all').prop("checked", false);
      localStorage.setItem("participantIdsSelectAll"+jobId, false);
    }

    return filteredallVals
  }

  /************************************************** */
  // 
  //              FIN HANDLER CHECKBOXES
  //
  /************************************************** */
});
